import { render, staticRenderFns } from "./nutritionalBalance.html?vue&type=template&id=2641532b&scoped=true&"
import script from "./nutritionalBalance.js?vue&type=script&lang=js&"
export * from "./nutritionalBalance.js?vue&type=script&lang=js&"
import style0 from "./nutritionalBalance.scss?vue&type=style&index=0&id=2641532b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641532b",
  null
  
)

export default component.exports